"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRewardRates = void 0;
const lodash_zip_1 = __importDefault(require("lodash.zip"));
// number of ms in one year
const ONE_YEAR_MS = 365 * 86400 * 1000;
/**
 * Calculate the rewards per second of all pools/total
 * @returns
 */
const calculateRewardRates = (getAllClaimableAmounts, msBetweenCheckpoints = ONE_YEAR_MS) => {
    const timeT0Ms = Date.now();
    const amountsT0 = getAllClaimableAmounts();
    const amountsT1 = getAllClaimableAmounts(msBetweenCheckpoints);
    if (!amountsT0 || !amountsT1) {
        return null;
    }
    return {
        timeT0Ms,
        amountsT0,
        pools: (0, lodash_zip_1.default)(amountsT0.allClaimable, amountsT1.allClaimable).map(([amt0, amt1]) => {
            if (!amt0 || !amt1) {
                return null;
            }
            return calculateRewardsPerSecond(amt0, amt1, msBetweenCheckpoints);
        }),
        total: amountsT0.sum && amountsT1.sum
            ? calculateRewardsPerSecond(amountsT0.sum, amountsT1.sum, msBetweenCheckpoints)
            : 0,
    };
};
exports.calculateRewardRates = calculateRewardRates;
const calculateRewardsPerSecond = (t0, t1, msBetweenCheckpoints) => {
    const t0Float = parseFloat(t0.toExact());
    const t1Float = parseFloat(t1.toExact());
    return ((t1Float - t0Float) / msBetweenCheckpoints) * 1000;
};
//# sourceMappingURL=calculateRewardRates.js.map